var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('testimonial',{attrs:{"items":_vm.items,"headline":"Testimonials from AI engineers hired by IM from our previous courses"}})}
var staticRenderFns = []

export { render, staticRenderFns }